// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__10jxf","buttons":"PendingPaymentAlert_buttons__CmcoB"};